import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";

type $Props = {
  classes: Object,
  isOpen: boolean,
  maxWidth?: number,
};

class Dropdown extends Component<$Props, $State> {
  render() {
    const { classes, children, isOpen } = this.props;
    return (
      <div
        className={classNames(classes.dropdown, isOpen ? classes.isOpen : null)}
      >
        {children}
      </div>
    );
  }
}

const styles = (theme) => ({
  dropdown: {
    display: "none",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "absolute",
    top: 58,
    left: 8,
    minWidth: 350,
    maxWidth: (props) => (props.maxWidth ? `${props.maxWidth}px` : "100%"),
    height: "auto",
    padding: 14,
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.gray["100"]}`,
    borderRadius: theme.globalBorderRadius,
    zIndex: theme.zIndex["dropdown"],
    "& > * + *": {
      marginLeft: 8,
    },
  },
  isOpen: {
    display: "flex",
  },
});

export default withStyles(styles, { name: "Dropdown" })(Dropdown);
